import { render, staticRenderFns } from "./FilesPane.vue?vue&type=template&id=7ee8f08b&scoped=true"
import script from "./FilesPane.vue?vue&type=script&lang=js"
export * from "./FilesPane.vue?vue&type=script&lang=js"
import style0 from "./FilesPane.vue?vue&type=style&index=0&id=7ee8f08b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee8f08b",
  null
  
)

export default component.exports